<template>
    <li>
        <css-prop :mode="'edit'" :selectedProp="cssProps[propertyName]"
                  :value="value"
                  :key="editedElementId"
                  :isTemplate="isTemplateGroup"
                  @newValue="updateProp($event)"
                  @selectedProperty=""
                  @delete="deleteProp"
                  v-if="parentPropName === 'style'"/>
        <div class="form-group position-relative position-relative py-2 " v-else>
            <label>{{propertyName}}:</label>
            <input type="text" class="form-control" name="inp"
                   :value="value"
                   @input="updateProp($event.target.value)">
            <button class="btn btn-xs btn-danger delete-prop-button"
                    name="remove"
                    @click="deleteProp">
                X
            </button>
        </div>
    </li>
</template>

<script type="text/babel">
import ObjectValueContent from './ObjectValueContent.vue';
import { mapGetters } from 'vuex';
import IdGetterMixin from './IdGetterMixin';
import CssProp from './CssProp/CssProp.vue';
import { getParsedCssProps } from '../../../../../utilities/css/cssProperties';

export default {
    name: 'ObjectValue',
    data () {
        return {
            value: '',
            cssProps: getParsedCssProps()
        };
    },
    props: {
        objValue: {
            required: true
        },
        propertyName: {
            required: true
        },
        path: {
            type: String
        },
        parentPropName: {
            type: [String, Number]
        },
        isTemplateGroup: {
            type: Boolean,
            default: false
        }
    },
    mixins: [IdGetterMixin],
    components: {
        ObjectValueContent,
        CssProp
    },
    watch: {
        objValue (newVal) {
            this.value = newVal;
        }
    },
    computed: {
        ...mapGetters({
            currentLayout: 'getCurrentLayout',
            rootPath: 'getEditedElementRootPath',
            editedElementId: 'getEditedElementId'
        }),
        completePath () {
            return `${this.rootPath}${this.path}.${this.propertyName}`;
        }
    },
    methods: {
        updateProp (val) {
            if(this.isTemplateGroup) {
                this.$emit('updatedValue', val);
                return 1;
            }
            let sanitizedPath = `currentLayout.${this.completePath}`.replace('..', '.');
            this.updateMetadataSource(`${this.parentPropName}.${this.propertyName}`, false);
            this.value = val.value || val;
            this.$vuexSet(sanitizedPath, this.value);
        },
        deleteProp () {
            if(this.isTemplateGroup) {
                this.$emit('deleteProp', this.propertyName);
                return 1;
            }
            this.updateMetadataSource(this.propertyName, true);
            this.$emit('deleteProp', this.propertyName);
        }
    },
    mounted (){
        this.value = this.objValue;
    },
    updated () {
        this.value = this.objValue;
    }
};
</script>
